module.exports = __webpack_public_path__ + "img/portage-outaouais.4dfc1378.png";